import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "label", "tooltip"]

  connect() {
    // Show tooltip by default to provide immediate context
    this.tooltipTarget.classList.remove("hidden")
  }

  // Remove file type restrictions - upscale checkbox is always enabled
  handleFileType(event) {
    // No-op - we no longer disable the checkbox based on file type
  }
} 